import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

export type Inspector = {
    inspectorId: string,
    inspectorName: string,
    address: string,
    phone: string,
};

const getListInspector = async (param: any) => {
    const query = `?search=${param.search}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Inspectors/GetAllInspector${query}`;
    return apiCall('get', URL);
};

const getInspectorById = async (id: string) => {
    const URL = `/Inspectors/GetInspectorById/${id}`;
    return apiCall('get', URL);
};

const getDataInspector = async () => {
    const URL = '/Inspectors/GetDataInspector';
    return apiCall('get', URL);
};

const getDataInspectorByType = async (param: any) => {
    const query = `?sire=${param.sire}&bire=${param.bire}&vetting=${param.vetting}`;
    const URL = `/Inspectors/GetDataInspectorByType${query}`;
    return apiCall('get', URL);
};

const updateStatusInspector = async (data: any) => {
    const URL = '/Inspectors/UpdateStatus';
    return apiCall('post', URL, data);
};

const putInspector = async (data: any) => {
    const URL = '/Inspectors/Update';

    try {
        const response = await axiosInstance.post<any[]>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const postInspector = async (data: any) => {
    const URL = '/Inspectors/Create';

    try {
        const response = await axiosInstance.post<any[]>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const deleteInspector = async (obj: any) => {
    const URL = '/Inspectors/Delete';
    return apiCall('post', URL, obj);
};

export {
    deleteInspector,
    postInspector,
    putInspector,
    updateStatusInspector,
    getInspectorById,
    getListInspector,
    getDataInspector,
    getDataInspectorByType,
};
